import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.css']
})
export class ManageComponent implements OnInit {
  title = 'Project Deployment Here';

  constructor() { }

  ngOnInit(){
  }

  unity(){
    let link = document.createElement("a");
    link.download = "Unity Green.apk";
    link.href = "assets/Apk/unity_green.apk";
    link.click();
}
  geoflow(){
    let link = document.createElement("a");
    link.download = "GeoFlow Creator.apk";
    link.href = "assets/Apk/geoflow_creator.apk";
    link.click();
}

geoscanner(){
  let link = document.createElement("a");
  link.download = "GeoScanner.apk";
  link.href = "assets/Apk/geoscanner.apk";
  link.click();
}

geoset(){
  let link = document.createElement("a");
  link.download = "GeoSet Creator.apk";
  link.href = "assets/Apk/geoset_creator.apk";
  link.click();
}



crProfile(){
window.open('/assets/cr_profile.pdf', '_blank');
}


}
